import { WitboostMarketplaceSearchDocument } from '@agilelab/plugin-wb-search-common';
import { Result } from '@mainstage/plugin-search-common';

const lorem =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

const fakeDescriptor: WitboostMarketplaceSearchDocument = {
  id: 'urn:dmb:cmp:marketing:fakeSystem:0:fakeComponent',
  info: {
    taskId: {
      type: 'string',
      label: 'Task ID',
      value: '"OK"',
    },
  },
  kind: 'outputport',
  name: 'fakeComponent',
  tags: new Array(20).fill(0).map((_, i) => ({
    tagFQN: `quite-long-tag-quite-long-tag-quite-long-tag${i + 1}`,
  })),
  title: 'fakeComponent',
  text: '',
  version: '0.0.0',
  location: '/marketplace/consumable-interface/160',
  platform: 'CDP on AWS',
  specific: {
    acl: {
      users: [],
      owners: [],
    },
    bucket: 'fds',
    folder: 'fsd',
    cdpEnvironment: 'fds',
  },
  dependsOn: [
    'urn:dmb:cmp:marketing:fakeSystem:0:fakeComponent',
    'urn:dmb:cmp:marketing:fakeSystem:0:fakeComponent',
  ],
  startDate: '2023-09-28T08:49:27.612Z',
  documentId: '160',
  sampleData: {},
  technology: 'S3',
  description: lorem,
  creationDate: '2023-09-28T08:49:27.612Z',
  dataContract: {
    SLA: {
      upTime: null,
      timeliness: null,
      intervalOfChange: null,
    },
    schema: [],
    endpoint: null,
    termsAndConditions: null,
  },
  _computedInfo: {
    kind: 'component',
    system_urn: 'urn:dmb:dp:marketing:fakeSystem:0',
    parent: {
      systemId: '1',
      displayName: 'Fake System',
    },
    owner: {
      ref: 'user:name.surname_agilelab.it',
      displayName: 'Name Surname',
    },
    taxonomy: {
      name: 'Data Mesh',
      external_id: 'urn:dmb:taxonomy:data-mesh-taxonomy',
    },
    publishedAt: '2024-04-12T13:21:24.658867+00:00',
    consumable: 'CONSUMABLE',
    environment: 'Prod',
    domain: {
      name: 'Finance',
      external_id: 'urn:dmb:dmn:finance',
    },
  },
  outputPortType: 'Files',
  semanticLinking: [],
  useCaseTemplateId: 'urn:dmb:utm:aws-cdp-outputport-s3-template:0.0.0',
  fullyQualifiedName: 'Fake component',
  processDescription: null,
  dataSharingAgreements: {
    billing: null,
    purpose: null,
    security: null,
    lifeCycle: null,
    limitations: null,
    intendedUsage: null,
    confidentiality: null,
  },
  infrastructureTemplateId: 'urn:dmb:itm:aws-cdp-outputport-s3-provisioner:0',
};

const fakeDescriptor2: WitboostMarketplaceSearchDocument = {
  id: 'urn:dmb:dp:sales:curie:0',
  info: {
    taskId: {
      type: 'string',
      label: 'Task ID',
      value: '"OK"',
    },
  },
  kind: 'dataproduct',
  name: 'curie',
  tags: new Array(20).fill(0).map((_, i) => ({
    tagFQN: `quite-long-tag-quite-long-tag-quite-long-tag${i + 1}`,
  })),
  email: 'fsdf@sdf.it',
  title: 'curie',
  text: '',
  domain: 'sales',
  status: 'Draft',
  billing: {},
  version: '0.2.0-SNAPSHOT-1',
  devGroup: 'bigdata',
  domainId: 'urn:dmb:dmn:sales',
  location: '/marketplace/search/129',
  maturity: null,
  specific: {},
  documentId: '129',
  ownerGroup: 'name.surname_agilelab.it',
  description: 'tovagliolo',
  environment: 'prod',
  _computedInfo: {
    kind: 'system',
    system_urn: 'urn:dmb:dp:sales:curie:0',
    taxonomy: {
      name: 'Data Mesh',
      external_id: 'urn:dmb:taxonomy:data-mesh-taxonomy',
    },
    owner: {
      ref: 'user:name.surname_agilelab.it',
      displayName: 'Name Surname',
    },
    domain: {
      name: 'Finance',
      external_id: 'urn:dmb:dmn:finance',
    },
    environment: 'Prod',
    publishedAt: '2024-04-12T13:21:24.658867+00:00',
  },
  informationSLA: null,
  dataProductOwner: 'user:name.surname_agilelab.it',
  useCaseTemplateId: 'urn:dmb:utm:dataproduct-aws-cdp-template:0.0.0',
  fullyQualifiedName: null,
  infrastructureTemplateId: 'urn:dmb:itm:cdp-aws-dataproduct-provisioner:1',
  dataProductOwnerDisplayName: 'Name Surname',
};

const fakeDescriptor3: WitboostMarketplaceSearchDocument = {
  id: 'urn:dmb:cmp:marketing:fakeSystem:0:anotherFakeComponent',
  info: {
    taskId: {
      type: 'string',
      label: 'Task ID',
      value: '"OK"',
    },
  },
  kind: 'outputport',
  name: 'fakeComponent',
  text: '',
  tags: [
    {
      state: 'Confirmed',
      source: 'Tag',
      tagFQN: 'experimental',
      labelType: 'Manual',
    },
    {
      state: 'Confirmed',
      source: 'Tag',
      tagFQN: 'structured',
      labelType: 'Manual',
    },
  ],
  title: 'fakeComponent',
  version: '0.0.0',
  location: '/marketplace/consumable-interface/159',
  platform: 'CDP on AWS',
  specific: {
    acl: {
      users: [],
      owners: [],
    },
    bucket: 'fds',
    folder: 'fsd',
    cdpEnvironment: 'fds',
  },
  dependsOn: [
    'urn:dmb:cmp:marketing:fakeSystem:0:anotherFakeComponent',
    'urn:dmb:cmp:marketing:fakeSystem:0:anotherFakeComponent',
  ],
  startDate: '2023-09-28T08:49:27.612Z',
  documentId: '160',
  sampleData: {},
  technology: 'S3',
  description: 'fdfsdfds',
  creationDate: '2023-09-28T08:49:27.612Z',
  dataContract: {
    SLA: {
      upTime: null,
      timeliness: null,
      intervalOfChange: null,
    },
    schema: [],
    endpoint: null,
    termsAndConditions: null,
  },
  _computedInfo: {
    kind: 'component',
    system_urn: 'urn:dmb:dp:marketing:fakeSystem:0',
    parent: {
      systemId: '1',
      displayName: 'Fake System',
    },
    owner: {
      ref: 'user:name.surname_agilelab.it',
      displayName: 'Name Surname',
    },
    domain: {
      name: 'Finance',
      external_id: 'urn:dmb:dmn:finance',
    },
    taxonomy: {
      name: 'Data Mesh',
      external_id: 'urn:dmb:taxonomy:data-mesh-taxonomy',
    },
    consumable: 'CONSUMABLE',
    environment: 'Prod',
  },
  outputPortType: 'Files',
  semanticLinking: [],
  useCaseTemplateId: 'urn:dmb:utm:aws-cdp-outputport-s3-template:0.0.0',
  fullyQualifiedName: 'Fake component',
  processDescription: null,
  dataSharingAgreements: {
    billing: null,
    purpose: null,
    security: null,
    lifeCycle: null,
    limitations: null,
    intendedUsage: null,
    confidentiality: null,
  },
  infrastructureTemplateId: 'urn:dmb:itm:aws-cdp-outputport-s3-provisioner:0',
};

const fakeDescriptor4: WitboostMarketplaceSearchDocument = {
  id: 'urn:dmb:cmp:marketing:fakeSystem:0:anotherFakeComponent',
  info: {
    taskId: {
      type: 'string',
      label: 'Task ID',
      value: '"OK"',
    },
  },
  kind: 'outputport',
  name: 'fakeComponent',
  text: '',
  tags: [
    {
      state: 'Confirmed',
      source: 'Tag',
      tagFQN: 'experimental',
      labelType: 'Manual',
    },
    {
      state: 'Confirmed',
      source: 'Tag',
      tagFQN: 'structured',
      labelType: 'Manual',
    },
  ],
  title: 'fakeComponent',
  version: '0.0.0',
  location: '/marketplace/consumable-interface/159',
  platform: 'CDP on AWS',
  specific: {
    acl: {
      users: [],
      owners: [],
    },
    bucket: 'fds',
    folder: 'fsd',
    cdpEnvironment: 'fds',
  },
  dependsOn: [
    'urn:dmb:cmp:marketing:fakeSystem:0:anotherFakeComponent',
    'urn:dmb:cmp:marketing:fakeSystem:0:anotherFakeComponent',
  ],
  startDate: '2023-09-28T08:49:27.612Z',
  documentId: '160',
  sampleData: {},
  technology: 'S3',
  description: 'fdfsdfds',
  creationDate: '2023-09-28T08:49:27.612Z',
  dataContract: {
    SLA: {
      upTime: null,
      timeliness: null,
      intervalOfChange: null,
    },
    schema: [],
    endpoint: null,
    termsAndConditions: null,
  },
  _computedInfo: {
    kind: 'component',
    system_urn: 'urn:dmb:dp:marketing:fakeSystem:0',
    parent: {
      displayName: 'Fake System',
      systemId: '1',
    },
    owner: {
      ref: 'user:name.surname_agilelab.it',
      displayName: 'Name Surname',
    },
    domain: {
      name: 'Finance',
      external_id: 'urn:dmb:dmn:finance',
    },
    taxonomy: {
      name: 'Data Mesh',
      external_id: 'urn:dmb:taxonomy:data-mesh-taxonomy',
    },
    consumable: 'CONSUMABLE',
    environment: 'Prod',
  },
  outputPortType: 'Files',
  semanticLinking: [],
  useCaseTemplateId: 'urn:dmb:utm:aws-cdp-outputport-s3-template:0.0.0',
  fullyQualifiedName: 'Fake component',
  processDescription: null,
  dataSharingAgreements: {
    billing: null,
    purpose: null,
    security: null,
    lifeCycle: null,
    limitations: null,
    intendedUsage: null,
    confidentiality: null,
  },
  infrastructureTemplateId: 'urn:dmb:itm:aws-cdp-outputport-s3-provisioner:0',
};

const fakeResults: Result<WitboostMarketplaceSearchDocument>[] = [
  {
    type: 'marketplace',
    document: fakeDescriptor,
  },

  {
    type: 'marketplace',
    document: fakeDescriptor2,
  },

  {
    type: 'marketplace',
    document: fakeDescriptor3,
  },

  {
    type: 'marketplace',
    document: fakeDescriptor4,
  },
];

export const generateFakeResults = (
  n: number,
): Result<WitboostMarketplaceSearchDocument>[] => {
  return new Array(n).fill(0).map((_, i) => ({
    ...fakeResults[i % fakeResults.length],
    document: {
      ...fakeResults[i % fakeResults.length].document,
      location: `/marketplace/search/29/${i}`,
    },
  }));
};
